// Copyright (c) 2019 Deere & Company

import Product, {getDefaultState as getProductDefaultState} from '@deere/cps-it.warranty-model-factory/lib/product';
import actions from '../../action-list';
import {getDefaultState} from '../state';

const resetProductDetails = () => getProductDefaultState();

const setProductDetails = (state, action) =>
    Product.update(state, {
        $set: action.data
    });

export default (state = getDefaultState().product, action) => {

    const actionTypes = {
        [actions.RESET_CLAIM_WEAR_PARTS]: resetProductDetails,
        [actions.RESET_CLAIM_WEAR_PARTS_PRODUCT_DETAILS]: resetProductDetails,
        [actions.SET_CLAIM_WEAR_PARTS_PRODUCT_DETAILS]: setProductDetails
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/claim/wear-parts/reducers/product-details.js